import * as React from 'react';
import classnames from 'classnames';

import { navigate } from 'libs/router';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { __t, applyTranslations } from 'utils/language';

import './title-with-back-to.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

interface Props {
  title: string,
  backToUrl: string,
  backToHoverText?: string,
  withBold?: boolean
}

const COMMON_MSG_KEY = 'collabary_common';

const TitleWithBackTo: React.FC<Props> = ({
  title,
  backToUrl,
  backToHoverText,
  withBold
}) => {
  const titleText = backToHoverText ?? __t(`${COMMON_MSG_KEY}.action_button.back`);

  const containerClasses = classnames('title-with-back-to', {
    'title-with-back-to--bold': Boolean(withBold)
  });

  const handleClick = (): void => {
    navigate.to(backToUrl);
  };

  return (
    <div
      title={titleText}
      className={containerClasses}
      onClick={handleClick}
    >
      <div className="title-with-back-to__chevron">
        <SVGDynamicIcon
          name="chevron-left-custom-fg"
          width={16}
          height={16}
          customColor="grey"
        />
      </div>
      <div className="title-with-back-to__title">
        {title}
      </div>
    </div>
  );
};

export default TitleWithBackTo;
